import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import loginReducer from './state/loginSlice';
import fileListReducer from './state/fileListSlice';
import datasetReducer from './state/datasetSlice';
import tabSelectReducer from './state/tabSelectSlice';
import { apiSlice } from './state/apiSlice';

const userReducer = combineReducers(
    {
        login: loginReducer,
        fileList: fileListReducer,
        dataset: datasetReducer,
        tabSelect: tabSelectReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    });

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return userReducer(undefined, action);
    }
    return userReducer(state, action);
};

// Dont save API calls from RTK Query, datasets or tabSelect between reloads.
// In the future, maybe replace with a whitelist for login to keep sessions between
// reloads but not the rest.
const persistConfig = {
    key: 'root',
    storage,
    blacklist: [apiSlice.reducerPath, 'dataset', 'tabSelect'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(apiSlice.middleware)
});
const persistor = persistStore(store);

export {
    store, persistor
};
